import { Role } from 'auth';
import { Navigate } from 'react-router-dom';
import { commonPaths } from '@/modules/common/routes.tsx';
import { adminDashboardPaths } from '@/modules/admin-dashboard/routes.tsx';
import { employeeDashboardPaths } from '@/modules/employee-dashboard/routes.tsx';

export const getUserDefaultRoute = (userRole: Role) => {
  if (userRole === Role.COMPLIANCE_USER) {
    return <Navigate to={employeeDashboardPaths.static.dashboard} />;
  }
  if (userRole === Role.COMPLIANCE_ADMIN) {
    return <Navigate to={adminDashboardPaths.static.dashboard} />;
  }
  return <Navigate to={commonPaths.static.notFound} />;
};
